import { ClusterActionsMenu } from 'components/cluster';
import { useHasLimitedFunctionality } from 'features-op/dashboard/hooks/useHasLimitedFunctionality';
import { Cluster, ClusterDisplayStatus } from '@cast/types';
import { useSearchContext } from '@cast/shared-search-ui';

type ClustersTableRowActionsProps = {
  cluster: Cluster;
  rowIndex: number;
};

export const ClustersTableRowActions = ({
  cluster,
  rowIndex,
}: ClustersTableRowActionsProps) => {
  const searchCtx = useSearchContext<Cluster>();
  const { hasLimitedFunctionality } = useHasLimitedFunctionality({
    totalClusters: searchCtx?.data?.length,
  });

  if (cluster.displayStatus === ClusterDisplayStatus.DISCOVERED) {
    return null;
  }

  return (
    <ClusterActionsMenu
      cluster={cluster}
      limitActions={hasLimitedFunctionality && rowIndex >= 5}
    />
  );
};
